import { useEffect, useState } from "react";
import { Star, Quote } from "lucide-react";
import { Carousel, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious } from "@/components/ui/carousel";
import { http, API } from "@/lib/api";

const Stars = ({ n }) => (
  <div className="flex gap-0.5 justify-center">
    {[1, 2, 3, 4, 5].map((i) => <Star key={i} size={12} className={i <= n ? "fill-[#7B5338] text-[#7B5338]" : "text-[#CDC0B0]"} />)}
  </div>
);

const ReviewCard = ({ r }) => (
  <div className="h-full bg-white rounded-xl sm:rounded-2xl border border-[#DDD3C6] overflow-hidden flex flex-col" data-testid={`review-card-${r.id}`}>
    {r.has_photo && <img src={`${API}/reviews/${r.id}/photo`} alt={r.name ? `Avis de ${r.name}` : "Avis client"} loading="lazy" className="w-full h-auto block" />}
    <div className="p-2 sm:p-4 flex-1 flex flex-col items-center text-center gap-2">
      <Stars n={r.rating} />
      {r.text && <p className="text-sm text-[#6B5F53] leading-relaxed flex-1"><Quote size={14} className="inline -mt-1 mr-1 text-[#7B5338]" />{r.text}</p>}
      {r.name && <p className="font-display text-lg uppercase tracking-[0.12em]">{r.name}</p>}
    </div>
  </div>
);

export const ReviewsSection = () => {
  const [reviews, setReviews] = useState(null);
  useEffect(() => {
    http.get("/reviews").then((r) => setReviews(r.data)).catch(() => setReviews([]));
  }, []);

  return (
    <section className="grad-taupe" data-testid="reviews-section">
      <div className="max-w-[1500px] mx-auto px-6 lg:px-10 py-24">
        <div className="text-center mb-12">
          <span className="text-[0.7rem] uppercase tracking-[0.22em] text-white/80">Ils nous ont fait confiance</span>
          <h2 className="font-display text-4xl lg:text-5xl mt-3 uppercase tracking-[0.1em] text-white">Nos avis & réalisations</h2>
        </div>
        {reviews && reviews.length === 0 && (
          <p className="text-center text-white/85" data-testid="reviews-empty">Les premiers avis et photos de nos réalisations arrivent très bientôt.</p>
        )}
        {reviews && reviews.length > 0 && (
          <Carousel opts={{ align: "start", loop: reviews.length > 4 }} className="px-1 sm:px-12" data-testid="reviews-carousel">
            <CarouselContent className="-ml-2 sm:-ml-4 items-start">
              {reviews.map((r) => (
                <CarouselItem key={r.id} className="pl-2 sm:pl-4 basis-1/3 sm:basis-1/4">
                  <ReviewCard r={r} />
                </CarouselItem>
              ))}
            </CarouselContent>
            <CarouselPrevious className="hidden sm:flex -left-2 bg-white border-[#C2B4A2]" data-testid="reviews-prev-button" />
            <CarouselNext className="hidden sm:flex -right-2 bg-white border-[#C2B4A2]" data-testid="reviews-next-button" />
          </Carousel>
        )}
      </div>
    </section>
  );
};
